import { render, staticRenderFns } from "./LiveDetailPrematchView.vue?vue&type=template&id=76e32851"
import script from "./LiveDetailPrematchView.vue?vue&type=script&lang=js"
export * from "./LiveDetailPrematchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports